// extracted by mini-css-extract-plugin
export default {"informer":"informer--z9an","text-box":"text-box--9QIy","payment":"payment--c4xb"};